// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-size: cover;
  background-position: center;
}

/* Background styles are now handled in App.tsx */

/* Password form styling - 90s raw HTML look */
.password-form {
  text-align: center;
  margin: 0 auto;
}

.password-input {
  font-family: monospace;
  border: 1px solid black;
  background-color: white;
  padding: 2px;
  margin-bottom: 10px;
  font-size: 14px;
}

.unlock-button {
  font-family: monospace;
  background-color: #c0c0c0;
  color: black;
  border: 2px outset #c0c0c0;
  padding: 2px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-top: 5px;
}

.unlock-button:active {
  border-style: inset;
}

/* Shake animation for wrong password */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.shake {
  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.App-logo {
  height: 40vmin;
  clip-path: ellipse(45% 43% at center);

}
.App-logo::after {
  height: 40vmin;
  clip-path: ellipse(45% 44% at center);
}

.background-wrapper {
  position: relative;
  width: 100%; /* Adjust as needed */
  height: 100vh; /* Adjust as needed */
  background-color: rgba(0, 0, 0, 20); /* Dark layer */
}

/* All Pages */
.centered {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  padding: 20px; /* Add some padding to prevent content from touching the edges */
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1; /* This will make the content take up all available space */
  
}


.black-background {
  background-color: rgb(105, 113, 132);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 0.8rem;
}

.cheat {
  color: red;
  font-size: 24px;
  text-decoration: none;
  background-color: transparent;
}

/* Info */
.understand-button {
  padding: 10px 20px;
  /* font-size: 16px; */
}
.fit-image {
  max-width: 65%; /* Adjust this to control how much of the background is visible */
  /* max-height: 50%; Reduce the max height to save space */
  object-fit: contain;
  margin-bottom: 10px; /* Add some space between the image and the button */
}

.decorator-image {
  width: 50%;
  height: auto;
  max-width: 500px;
  margin-bottom: 20px;
}

/* Location */
@keyframes moveUpDown {
  0%, 100% {
    transform: translateY(0);  /* Start and end at the same position */
  }
  50% {
    transform: translateY(20px); /* Move down 20 pixels */
  }
}

/* Location link styling with animation */
.location-link {
  text-decoration: none;
  background-color: white;
  color: teal;
  padding: 10px;
  border-radius: 5px;

  /* Applying the animation */
  animation: moveUpDown 2s linear infinite; /* 2 seconds duration, linear timing, infinite repeat */
}

body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
/* Footer.css */
/* Footer.css */
.footer {
  color: white;
  position: sticky;
  bottom: 30px;
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,iDAAiD;;AAEjD,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,2BAA2B,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,cAAc;EACd,qCAAqC;;AAEvC;AACA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,qBAAqB;EAClC,aAAa,EAAE,qBAAqB;EACpC,mCAAmC,EAAE,eAAe;AACtD;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,aAAa,EAAE,gEAAgE;AACjF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAO,EAAE,2DAA2D;;AAEtE;;;AAGA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc,EAAE,iEAAiE;EACjF,yDAAyD;EACzD,mBAAmB;EACnB,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE;IACE,wBAAwB,GAAG,uCAAuC;EACpE;EACA;IACE,2BAA2B,EAAE,wBAAwB;EACvD;AACF;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,kBAAkB;;EAElB,2BAA2B;EAC3B,wCAAwC,EAAE,uDAAuD;AACnG;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA,eAAe;AACf,eAAe;AACf;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background-size: cover;\n  background-position: center;\n}\n\n/* Background styles are now handled in App.tsx */\n\n/* Password form styling - 90s raw HTML look */\n.password-form {\n  text-align: center;\n  margin: 0 auto;\n}\n\n.password-input {\n  font-family: monospace;\n  border: 1px solid black;\n  background-color: white;\n  padding: 2px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.unlock-button {\n  font-family: monospace;\n  background-color: #c0c0c0;\n  color: black;\n  border: 2px outset #c0c0c0;\n  padding: 2px 8px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 5px;\n}\n\n.unlock-button:active {\n  border-style: inset;\n}\n\n/* Shake animation for wrong password */\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\n}\n\n.shake {\n  animation: shake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n}\n\n.App-logo {\n  height: 40vmin;\n  clip-path: ellipse(45% 43% at center);\n\n}\n.App-logo::after {\n  height: 40vmin;\n  clip-path: ellipse(45% 44% at center);\n}\n\n.background-wrapper {\n  position: relative;\n  width: 100%; /* Adjust as needed */\n  height: 100vh; /* Adjust as needed */\n  background-color: rgba(0, 0, 0, 20); /* Dark layer */\n}\n\n/* All Pages */\n.centered {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  padding: 20px; /* Add some padding to prevent content from touching the edges */\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 1; /* This will make the content take up all available space */\n  \n}\n\n\n.black-background {\n  background-color: rgb(105, 113, 132);\n  color: white;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 0.8rem;\n}\n\n.cheat {\n  color: red;\n  font-size: 24px;\n  text-decoration: none;\n  background-color: transparent;\n}\n\n/* Info */\n.understand-button {\n  padding: 10px 20px;\n  /* font-size: 16px; */\n}\n.fit-image {\n  max-width: 65%; /* Adjust this to control how much of the background is visible */\n  /* max-height: 50%; Reduce the max height to save space */\n  object-fit: contain;\n  margin-bottom: 10px; /* Add some space between the image and the button */\n}\n\n.decorator-image {\n  width: 50%;\n  height: auto;\n  max-width: 500px;\n  margin-bottom: 20px;\n}\n\n/* Location */\n@keyframes moveUpDown {\n  0%, 100% {\n    transform: translateY(0);  /* Start and end at the same position */\n  }\n  50% {\n    transform: translateY(20px); /* Move down 20 pixels */\n  }\n}\n\n/* Location link styling with animation */\n.location-link {\n  text-decoration: none;\n  background-color: white;\n  color: teal;\n  padding: 10px;\n  border-radius: 5px;\n\n  /* Applying the animation */\n  animation: moveUpDown 2s linear infinite; /* 2 seconds duration, linear timing, infinite repeat */\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n/* Footer.css */\n/* Footer.css */\n.footer {\n  color: white;\n  position: sticky;\n  bottom: 30px;\n  width: 100%;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
